@if (hasDiningCard) {
<div class="dining-card">
  <div class="dining-card__wrapper">
    <mb-icon icon="magic"></mb-icon>
    <div>
      <p class="dining-card__title">
        {{ diningCardTitle }}
      </p>
      @if (!isFreeMealPlan) {
      <p class="dining-card__text">
        Obtené este beneficio sumando a tu reserva 4 o más días en los parques. Solo se puede usar para comprar
        alimentos y bebidas.
      </p>
      }
      @if (isFreeMealPlan) {
      <p class="dining-card__text">
        Sumando a tu reserva 4 o más días en los parques con entradas <i>Park Hopper o Park Hopper Plus</i>.
      </p>
      }
    </div>
  </div>
</div>
}

<div
  class="cluster-wrapper"
  [class.dining-card__border]="hasDiningCard">
  <div class="rooms-container">

    @for (room of cluster?.rooms; track $index) {
    <room
      [room]="room"
      [idHotel]="hotelAvailabilityInfo?.id"
      [mealPlan]="defaultRate.meal_plan.code"
      [index]="$index"
      [numberRoom]="$index + 1"
      [latestRooms]="selectedPlan?.rates?.[index]?.latest_rooms"
      [offerCodes]="cluster.offerCodes"
      [isDisney]="true"
    ></room>
    }

  </div>
  <div class="rates-container">
    <div class="rate">
      <div class="meal-plan-container">
        <div class="combo-ticket">
          <combo-ticket
            [hasMealPlan]="hasMealPlan"
            [isFreeMealPlan]="isFreeMealPlan"
            [hasTickets]="hasTickets"
            [optionalSupplements]="hasRoomOnlyOption">
          </combo-ticket>
        </div>
      </div>
      <div class="payment-method-advice">
        <div class="room">
          @if (selectedRate.price.discount.percentage >= 5 && isMobile) {
          <mb-advice
            align="left"
            class="gift">
            {{ selectedRate.price.discount.percentage | number: '1.0-0' }}% OFF
          </mb-advice>
          }
          @if (!isMobile) {
          <div class="payment-method">
            <mb-badge class="payment-method__badge">
              <mb-icon
                class="icon"
                [icon]="
                selectedRate.payment_method.code === 'PREPAID'
                  ? 'prepaid'
                  : 'pay-at-destination'
              "
              ></mb-icon>
              <span class="text">{{ selectedRate.payment_method.description }}</span>
            </mb-badge>
            <payment-advise-info
              [isExperts]="isExperts"
              [isCurrencyUSD]="isCurrencyUSD"
              [rate]="selectedRate"
              [isArgentina]="false"
            ></payment-advise-info>
          </div>
          }
          @if (selectedRate?.price?.discount?.amount && selectedRate?.price?.discount?.percentage >= 5) {
          <p
            class="discount without-promo">
            <span>$&nbsp;</span>
            <strong class="important" id="clean-price-{{ selectedRate.id }}">{{
                pricePerNightWithoutDiscount | Currency
              }}</strong>
          </p>
          }
        </div>
      </div>
      <div class="total-price-container">
        @if (isMobile) {
        <div class="payment-method-mobile">
          <span class="text">{{ selectedRate.payment_method.description }}</span>
        </div>
        }
        @if (isAvailable) {
          @if (selectedRate.price.discount.percentage >= 5 && !isMobile) {
          <mb-advice
            align="right"
            color="success"
            class="gift"
          >
            {{ selectedRate.price.discount.percentage | number: '1.0-0' }}% OFF
          </mb-advice>
          }
          @if (isExperts) {
          <am-trips-add-product
            [productType]="productType"
            [product]="tripFavoriteData"
            [currencyCode]="currencyCodeToTripFavorite"
          ></am-trips-add-product>
          }
          @if (!isAlliance) {
          <am-price
            [fop]="selectedRate.payment_method.code"
            [rateSelected]="selectedRate"
            [isDisney]="true"
            [showAmountTotal]="priceByValue === 'TOTAL'"
            [quantityNights]="quantityNights"
            [guests]="quantityGuests"
            [quantityRooms]="quantityRooms"
            [isArgentinian]="isArgentinian"
          >
          </am-price>
          }
          @if (isAlliance) {
          <am-rewards-pricing
            [price]="
            superclubPrice(
              priceTotal +
                getRateSupplement(selectedRate, 'MEAL')?.amount +
                getRateSupplement(selectedRate, 'TICKET')?.amount | Currency
            )
          "
          ></am-rewards-pricing>
          }
        } @else {
          <span
            class="rate-unavailable"
            i18n="@@ups_esta_opcion_ya_no_esta_disponible_proba_eligiendo_otra"
          >Ups, esta opción ya no está disponible. ¡Probá eligiendo otra!</span>
        }
        <button
          mb-button
          mb-button-fullwidth
          variant="principal"
          color="primary"
          [loading]="loading"
          (click)="bookRate()"
          [disabled]="!isAvailable">
          Seleccionar
        </button>
        <am-experts-compensation
          [channel]="'web'"
          [margin]="commission"
          [productType]="'HOTEL'"
          [brand]="'almundo'"
          [currency]="selectedRate.price.currency.code">
        </am-experts-compensation>
      </div>
    </div>
  </div>
</div>
